// import React, { useState } from "react";
// import "./Admindirectory.css";
// import Hrmdashbord from './Hrmdashbord';
// import OnboardingEmployees from './OnboardingEmployees';

// const TabsLayout = () => {
//   const [activeTab, setActiveTab] = useState("Dashboard");

//   /* ===== COMMON DUMMY SECTION ===== */
//   const DummySection = ({ title }) => {
//     return (
//       <div className="dummy-box">
//         <h2>{title}</h2>
//         <p>
//           This is a dummy section for <strong>{title}</strong>.
//         </p>
//         <span>Content will be added later 🚧</span>
//       </div>
//     );
//   };

//   /* ===== RENDER CONTENT ===== */
//   const renderComponent = () => {
//     switch (activeTab) {
//       case "Dashboard":
//         return <Hrmdashbord title="Dashboard" />;

//       case "Onboarding":
//         return <OnboardingEmployees title="Onboarding" />;

//       case "Profile":
//         return <DummySection title="Profile" />;

//       case "HR Executive":
//         return <DummySection title="HR Executive" />;

//       case "HR Manager":
//         return <DummySection title="HR Manager" />;

//       case "Summary":
//         return <DummySection title="Summary" />;

//       case "Hierarchical":
//         return <DummySection title="Hierarchical" />;

//       default:
//         return <DummySection title="Dashboard" />;
//     }
//   };

//   const tabs = [
//     "Dashboard",
//     "Onboarding",
//     "Profile",
//     "HR Executive",
//     "HR Manager",
//     "Summary",
//     "Hierarchical",
//   ];

//   return (
//     <div className="tabs-wrapper">
//       {/* LEFT SIDE TABS */}
//       <div className="tabs-sidebar">
//         {tabs.map((tab) => (
//           <button
//             key={tab}
//             className={`tab-btn ${activeTab === tab ? "active" : ""}`}
//             onClick={() => setActiveTab(tab)}
//           >
//             {tab}
//           </button>
//         ))}
//       </div>

//       {/* RIGHT SIDE CONTENT */}
//       <div className="tabs-content">
//         {renderComponent()}
//       </div>
//     </div>
//   );
// };

// export default TabsLayout;



import React, { useState } from "react";
import "./Admindirectory.css";
import Hrmdashbord from "./Hrmdashbord";
import OnboardingEmployees from "./OnboardingEmployees";
import ProfileTable from "./ProfileTable";
import HRExecutiveTabl from "./HRExecutiveTabl";
import HRManagerTable from "./HRManagerTable";
import HRSummary from "./HRSummary";
import HierarchicalChart from "./HierarchicalChart";

const TabsLayout = () => {
  const [activeTab, setActiveTab] = useState("Dashboard");

  const DummySection = ({ title }) => (
    <div className="dummy-box">
      <h2>{title}</h2>
      <p>This is a dummy section for <strong>{title}</strong>.</p>
      <span>Content will be added later 🚧</span>
    </div>
  );

  const renderComponent = () => {
    switch (activeTab) {
      case "Dashboard":
        return <Hrmdashbord />;
      case "Onboarding":
        return <OnboardingEmployees />;
      case "Profile":
        return <ProfileTable title="Profile" />;
      case "HR Executive":
        return <HRExecutiveTabl title="HR Executive" />;
      case "HR Manager":
        return <HRManagerTable title="HR Manager" />;
      case "Summary":
        return <HRSummary title="Summary" />;
      case "Hierarchical":
        return <HierarchicalChart title="Hierarchical" />;
      default:
        return <Hrmdashbord />;
    }
  };

  const tabs = [
    "Dashboard",
    "Onboarding",
    "Profile",
    "HR Executive",
    "HR Manager",
    "Summary",
    "Hierarchical",
  ];

  return (
    <div className="tabs-wrapper">
      {/* TOP ONE-ROW TABS (ALL SCREENS) */}
      <div className="tabs-row">
        {tabs.map((tab) => (
          <span
            key={tab}
            className={`row-tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </span>
        ))}
      </div>

      {/* CONTENT */}
      <div className="tabs-content">
        {renderComponent()}
      </div>
    </div>
  );
};

export default TabsLayout;

